import React from "react";
import galleryImage from "../../images/galleryImage.png";
import { BASE_URL } from "../../constant/constant";
import { parseCustomCss } from "../../Pages/FlexibleLayout/utils";

export const ImagePreview = ({ config, classes }) => {
  const modifiedRepoSource = config?.repo_source ? `${BASE_URL}/api/v1/public/${config?.repo_source}` : "";
  const imageSource = modifiedRepoSource || config?.source || galleryImage;
  const title =
    config?.type === "field"
      ? config?.activity_label && config?.display
        ? `${config.activity_label} - ${config.display}`
        : config?.activity_label || config?.display
      : config?.display || config?.type || config?.name;
  const customStyles = config?.custom_css ? parseCustomCss(config.custom_css) : {};

  return (
    <img style={{ width: "100%", ...customStyles }} className={classes} src={imageSource} alt="img" title={title} />
  );
};
